import reducer from './reducer';
import saga from './saga';

export default {
  reducer,
  saga
};
